var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgElectricity = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.934 2c-.784 0-1.417.614-1.417 1.375V7.5h2.834V3.375C10.35 2.615 9.718 2 8.934 2zm8.5 0c-.784 0-1.417.614-1.417 1.375V7.5h2.834V3.375c0-.76-.633-1.375-1.417-1.375zM6.101 8.875c-.784 0-1.417.614-1.417 1.375 0 .76.633 1.375 1.417 1.375V13c0 3.326 2.435 6.102 5.666 6.738v2.887c0 .76.633 1.375 1.417 1.375s1.417-.614 1.417-1.375v-2.887c3.231-.636 5.666-3.412 5.666-6.738v-1.375c.784 0 1.417-.614 1.417-1.375 0-.76-.633-1.375-1.417-1.375H6.101z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgElectricity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/electricity.00747a12.svg";
export { ForwardRef as ReactComponent };